import { cn } from "@/lib/utils";
import type { DataTableFeatures } from "@/types/dataTableSettings";

export function getRowPropsWithDraftHighlight(
  draftIds: Set<string> | undefined,
  baseGetRowProps?: DataTableFeatures["getRowProps"],
): DataTableFeatures["getRowProps"] {
  if (!draftIds?.size) return baseGetRowProps;

  return (row) => {
    const base = baseGetRowProps?.(row) ?? {};
    const baseClassName =
      typeof base.className === "string" ? base.className : undefined;
    const id = (row.original as { id?: string } | null)?.id;
    return {
      ...base,
      className: cn(baseClassName, id && draftIds.has(id) && "bg-amber-50"),
    };
  };
}
